import { apiService } from '@/api';

function getUser() {
  const endpoint = `/connect/userinfo`;
  return apiService.get(endpoint, {
    baseURL: import.meta.env.VITE_APP_IDENTITY_API_URL
  });
}

function getCompany() {
  const endpoint = `/companies`;
  return apiService.get(endpoint, {
    baseURL: import.meta.env.VITE_APP_CATALOG_API_URL
  });
}

function getAllInspireCompanies() {
  const endpoint = `/companies`;
  return apiService.get(endpoint, {
    baseURL: import.meta.env.VITE_APP_ADMIN_API_URL
  });
}

export const userApi = {
  getUser,
  getCompany,
  getAllInspireCompanies
};
